// import homePage from './pages/home-page';
// import teamPage from './pages/team-page';
// import aboutPage from './pages/about-page';
// import careersPage from './pages/careers-page';
// import awardsPage from './pages/awards-page';
// import investorsOverviewPage from './pages/investors-overview-page';
// import investorsReportsPage from './pages/investors-reports';
// import investorsAnnouncementsPage from './pages/investors-announcements';
// import investorsDocsPage from './pages/investors-docs';
// import portfolioOverviewPage from './pages/portfolio-overview';
// import portfolioPropertiesPage from './pages/portfolio-properties';
// import portfolioCasePage from './pages/portfolio-case';
// import portfolioRentPage from './pages/portfolio-rent';
// import portfolioProjectPage from './pages/portfolio-project';
// import sustainabilityOverviewPage from './pages/sustainability-overview';
// import sustainabilityEnvironmentPage from './pages/sustainability-environment';
// import sustainabilityInvestmentPage from './pages/sustainability-investment';
// import sustainabilitySportsPage from './pages/sustainability-sports';
// import sustainabilityReportsPage from './pages/sustainability-reports';
// import sustainabilityCovid19Page from './pages/sustainability-covid19';
// import sustainabilityGlobalPage from './pages/sustainability-global';
// import mediaOverviewPage from './pages/media-overview';
// import mediaNewsPage from './pages/media-news';
// import mediaCasePage from './pages/media-case';
// import mediaDownloadsPage from './pages/media-downloads';
// import contactPage from './pages/contact';

export default function() {
  const pageName = document.body.getAttribute('data-page-name');
  if (!pageName) return;

  const pageList = {
    // homePage, teamPage, aboutPage, careersPage, awardsPage, investorsOverviewPage, investorsReportsPage, investorsAnnouncementsPage, investorsDocsPage, portfolioOverviewPage, portfolioPropertiesPage, portfolioCasePage, portfolioRentPage, portfolioProjectPage, sustainabilityOverviewPage, sustainabilityEnvironmentPage, sustainabilityInvestmentPage, sustainabilitySportsPage, sustainabilityReportsPage, sustainabilityCovid19Page, sustainabilityGlobalPage, mediaOverviewPage, mediaNewsPage, mediaCasePage, mediaDownloadsPage, contactPage,
  };

  if (pageName && pageList[pageName]) pageList[pageName]();
}
